module.exports = __webpack_public_path__ + "static/branding.529d5305.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/assets/branding.jpg
// module id = 339
// module chunks = 35783957827783